module.exports = __webpack_public_path__ + "img/noimg.187c30f6.png";